import SiteSearchCombobox from './SiteSearchCombobox';

export { type SiteSearchComboboxProps } from './SiteSearchCombobox';
export default SiteSearchCombobox;
